
import './NavbarGlobal.scss';

import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import MenuIcon from '@mui/icons-material/Menu';
import { Button, IconButton} from '@mui/material';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Typography from '@mui/material/Typography';
import React, { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation, useNavigate } from 'react-router-dom';

import AuthContext from '../../../Contexts/AuthProvider';
import { Langue } from '../../../Contexts/lang/Langue';
import Logo from '../../../data/Logo';
import useLogout from '../../../hooks/useLogout';
import useRole from '../../../hooks/useRole';
import useUtilities from '../../../hooks/useUtilities';
import useWindowSize from '../../../hooks/useWindowSize';
import { isUrlFromCompleterProfile, UpperCasePrenomNomFromAuth } from '../../../Utils/utils';
//import Logout from '../../Auth/Logout';
import { buttonStyles } from '../../docsAdministrative/JsObjectStyles';
//import { MessageBar } from './MessageBar';
import { NotificationBarUsingMenu } from './NotificationBar';

function NavbarGlobal() {

    const { auth } = useContext(AuthContext);
    console.log('auth',auth);
    const navigate = useNavigate();
    const role = useRole();
    const { pathname } = useLocation();
    const { sideBarOpen,setSideBarOpen} = useUtilities();
    const [anchorElUser, setAnchorElUser] = useState(false);
    const { i18n } = useTranslation();
    const {device}=useWindowSize();
    const handleOpenUserMenu = () => {
        if (anchorElUser == true)
            setAnchorElUser(false);
        else
            setAnchorElUser(true);
    };
    const handleCloseUserMenu = () => {
        setAnchorElUser(false);
    };
    const logout = useLogout();
    const signOut = async () => {
        await logout();
        navigate('/');
    };

    function toogleOpen() {
        setSideBarOpen(!sideBarOpen);
    }

    return (
        <React.Fragment>
            <div
                className='frame6NavBarGlobal'
                //style={{justifyContent:device=='desktop'?'space-between':'flex-end'}}
                style={{justifyContent:((isUrlFromCompleterProfile(pathname) || (!isUrlFromCompleterProfile(pathname) && device!='desktop')) ?'space-between':'flex-end')}}
            >
                {((isUrlFromCompleterProfile(pathname)) || device!='desktop')&&
                    <div style={{display:'flex',flexDirection:'row',justifyContent:'flex-start',gap:'8px'}}>
                        {(device!='desktop' && sideBarOpen) &&
                        <IconButton
                            onClick={toogleOpen}
                            sx={{
                                padding: '4px',
                                color: 'black',
                                zIndex:'3000',
                                backgroundColor: 'white',
                                '&:hover': {
                                    backgroundColor: '#26284687',
                                },
                            }}
                        >
                            <MenuIcon
                                sx={{
                                    color:'balck',
                                    fontFamily: 'Lato',
                                    fontStyle: 'normal',
                                    fontWeight: '400',
                                    fontSize: '14px',
                                    lineHeight: '24px',
                                    height:'34px',
                                    width:'24px',
                                    /* identical to box height, or 150% */
                                    letterSpacing: '-0.0044em',
                                }}
                            />
                        </IconButton>
                        }
                        <div
                            className='LogoStyleNavBarGlobal'
                            style={{marginTop:'9px',marginLeft:device=='desktop'?'0px':'-10px'}}
                        >
                            <Link to={`/${role}`} >
                                {/* ? if we want to use props, but we have already the info on context, no need <Link to={`/${role}`}
                                {/* <Trans>AOs</Trans> */}
                                <Logo
                                    width='102px'
                                    height={device=='desktop'?'28px':'23px'}
                                />
                            </Link>
                        </div>
                    </div>
                }

                <div className='LoginNavBarGlobal'>
                    <div className='frame0NavBarGlobal'>
                        {/*
                        hide for v0
                        <div className='envl'>
                            <MessageBar />
                        </div>*/}
                        <div className='Notif'>
                            {/* <NotificationBar
                                notifications={notifications}
                            />
                            <NotificationBarUsingList
                                notifications={notifications}
                            /> */}
                            <NotificationBarUsingMenu />
                        </div>
                        {/*<div className='frame7NavBarGlobal'>
                            <Logout />
                        </div>*/}
                        <div className='Seconnecte'>
                            {device=='desktop' &&
                            // #pour v2
                            <div className='frame1NavBarGlobal'>
                                <Langue />
                            </div>
                            }
                            <div className='frame2NavBarGlobal'>
                            </div>
                            <div className='frame3NavBarGlobal'>
                                {device=='desktop' &&
                                <Button
                                    variant="text"
                                    startIcon={
                                        <img
                                            src={auth?.photo || 'https://cdn.icon-icons.com/icons2/1378/PNG/512/avatardefault_92824.png'}
                                            //alt="photo"
                                            width="30px"
                                        />
                                    }
                                    style={{...buttonStyles(),...{color:' #272D3C'}}}
                                    endIcon={anchorElUser ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                                    //onClick={navigate('profile')}
                                    onClick={handleOpenUserMenu}
                                >
                                    {UpperCasePrenomNomFromAuth(auth?.nom,auth?.prenom)}
                                </Button>
                                }
                                {device!='desktop' &&
                                <IconButton
                                    //variant="text"
                                    //startIcon={
                                    //}
                                    //style={{...buttonStyles(),...{color:' #272D3C'}}}
                                    //endIcon={anchorElUser ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                                    //onClick={navigate('profile')}
                                    onClick={handleOpenUserMenu}
                                >
                                    <img
                                        src={'https://cdn.icon-icons.com/icons2/1378/PNG/512/avatardefault_92824.png'}
                                        //alt="photo"
                                        width="30px"
                                    />
                                </IconButton>
                                }
                                <Menu
                                    sx={{ mt: '80px', ml: '-30px' }}
                                    id="menu-appbar"
                                    anchorOrigin={{
                                        vertical: 'top',
                                        horizontal: 'right',
                                    }}
                                    transformOrigin={{
                                        vertical: 'top',
                                        horizontal: 'right',
                                    }}
                                    anchorEl={anchorElUser}
                                    open={Boolean(anchorElUser)}
                                    onClose={handleCloseUserMenu}
                                >
                                    <MenuItem
                                        key='profile'
                                        onClick={() => {
                                            handleCloseUserMenu();
                                            if(role=='expert')
                                                navigate(`/${role}/donneeProfile`);
                                            else if(role=='client' || role=='esn')
                                                navigate(`/${role}/Profile`);
                                            else
                                                navigate(`/${role}/profilPersonnel`);
                                        }}
                                    >
                                        <Typography textAlign="center">{i18n.t('Profil')}</Typography>
                                    </MenuItem>
                                    <MenuItem
                                        key='parametreCompte'
                                        onClick={() => {
                                            handleCloseUserMenu();
                                            navigate(`/${role}/parametreCompte`);
                                        }}
                                    >
                                        <Typography textAlign="center">{i18n.t('Paramètres du compte')}</Typography>
                                    </MenuItem>
                                    <MenuItem
                                        key='Deconnexion'
                                        onClick={signOut}
                                    >
                                        <Typography textAlign="center">{i18n.t('Déconnexion du compte')}</Typography>
                                    </MenuItem>
                                </Menu>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}

export default NavbarGlobal;